import { createFileRoute } from '@tanstack/react-router'
import { IntegrationsPage } from '@/pages/integrations'

export const Route = createFileRoute('/(protected)/workspace/integrations/')({
  component: IntegrationsPage,
  staticData: {
    pageHeader: { title: 'Integrations', pad: false },
  },
})
